import React from "react";
import "./ExcelExportButton.css";

const ExcelExportButton = ({
  onClick,
  loading = false,
  disabled = false,
  title = "Download Excel",
  className = "",
  label = "Excel",
  loadingLabel = "Exporting...",
}) => (
  <button
    type="button"
    className={["excel-export-button", className].filter(Boolean).join(" ")}
    onClick={onClick}
    disabled={disabled || loading}
    title={title}
  >
    <i className="bi bi-file-earmark-spreadsheet" aria-hidden />
    <span>{loading ? loadingLabel : label}</span>
  </button>
);

export default ExcelExportButton;
